(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropriedadeDialogController', PropriedadeDialogController);

    PropriedadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Propriedade', 'Georeferenciamento', 'Concentracaoidealatributo', 'Pesquisa', 'Aquisicao', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Propostareceituario', 'Cidade', 'Monitoramentoportatil', 'Controleaplicacao', 'Pessoapropriedade', 'Cooperativa', 'Diariodebordo', 'Automatizacao', 'Fazenda'];

    function PropriedadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Propriedade, Georeferenciamento, Concentracaoidealatributo, Pesquisa, Aquisicao, Concentracaoindice, Imagemtermica, Mapaimagem, Propostareceituario, Cidade, Monitoramentoportatil, Controleaplicacao, Pessoapropriedade, Cooperativa, Diariodebordo, Automatizacao, Fazenda) {
        var vm = this;

        vm.propriedade = entity; 
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.georeferenciamentos = Georeferenciamento.query();
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();
        vm.pesquisas = Pesquisa.query();
        vm.aquisicaos = Aquisicao.query();
        vm.concentracaoindices = Concentracaoindice.query();
        vm.imagemtermicas = Imagemtermica.query();
        vm.mapaimagems = Mapaimagem.query();
        vm.propostareceituarios = Propostareceituario.query();
        //vm.cidades = Cidade.query();
        vm.monitoramentoportatils = Monitoramentoportatil.query();
        vm.controleaplicacaos = Controleaplicacao.query();
        vm.pessoapropriedades = Pessoapropriedade.query();
        vm.cooperativas = Cooperativa.query();
        vm.diariodebordos = Diariodebordo.query();
        vm.automatizacaos = Automatizacao.query();
        vm.fazendas = Fazenda.query(
            {
                size:1000,
                sort:"nome,asc"
            }
        );

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.propriedade.id !== null) {
                Propriedade.update(vm.propriedade, onSaveSuccess, onSaveError);
            } else {
                Propriedade.save(vm.propriedade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propriedadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagempropriedade = function ($file, propriedade) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.imagempropriedade = base64Data;
                        propriedade.imagempropriedadeContentType = $file.type;
                    });
                });
            }
        };

        vm.setRegressao = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.regressao = base64Data;
                        propriedade.regressaoContentType = $file.type;
                    });
                });
            }
        };

        vm.setDistribuicao = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.distribuicao = base64Data;
                        propriedade.distribuicaoContentType = $file.type;
                    });
                });
            }
        };

        vm.setBorda = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.borda = base64Data;
                        propriedade.bordaContentType = $file.type;
                    });
                });
            }
        };

        vm.setKML = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.kml = base64Data;
                        propriedade.kmlContentType = $file.type;
                    });
                });
            }
        };

    }
})();
